import React from 'react'
import { IconCircleExclamation } from '../../../shared/icon/icon'
import { ErrorReference } from '../../../shared/error/error-reference'

// What happened to the last code, in its own small card under Cancel /
// Paste Code (owner 2026-10-08: "Can't we put the errors below the buttons,
// maybe in their own info card?"). A refusal -- no device waiting, too many
// tries -- is a soft warning with the server's sentence. A real failure (a
// 5xx, or no answer at all) is a soft danger card, with the failed request's
// reference on one line when there is one (and the Request log for a super
// admin).
export const LookupNotice = ({ message, failure, fault }) => (
  <div className={`ld-notice ${fault ? 'ld-notice--danger' : 'ld-notice--warning'}`} data-testid="ld-notice">
    <IconCircleExclamation className="ld-notice__icon" />
    <div className="ld-notice__body">
      <div className="ld-notice__text">{message}</div>
      {fault && failure && <ErrorReference error={failure} compact className="ld-notice__ref" />}
    </div>
  </div>
)
